import React from 'react';
import style from './row.module.scss';
import classNames from 'classnames';

enum Background {
    Transparent,
    Grey,
    LightestGrey,
    White,
    Default = Transparent
}

interface RowProps extends React.InputHTMLAttributes<HTMLDivElement> {
    background?: Background;
    trimmedBackground?: boolean;
    className?: string;
}

const Row: React.SFC<RowProps> =
    ({background = Background.Default, trimmedBackground = false, children, className, ...rest}) =>
(
    <div
        className={classNames({
            [style.TransparentBackground]: background === Background.Transparent,
            [style.GreyBackground]: background === Background.Grey,
            [style.LightestGreyBackground]: background === Background.LightestGrey,
            [style.WhiteBackground]: background === Background.White,
            [style.TrimmedBackground]: trimmedBackground,
        })}
    >
        <div className={classNames(className, style.RowContainer)} {...rest}>
            {children}
        </div>
    </div>
);

export { Background, Row };
export type { RowProps };
